import authEmailSlice from './slice'

export default authEmailSlice.actions
